import { apiSlice } from "../api/apiSlice";

export const progressSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProgress: builder.query({
      query: () => `/my/progress`,
      providesTags: (result, error, arg) => [{ type: "Progress" }],
    }),
  }),
});

export const { useGetProgressQuery } = progressSlice;
